import Layout from '../../components/Layout';
import Head from 'next/head';
import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useRouter } from "next/router";
import ContactUs from '../../components/contactUs/contactUs';
import axiosInstance from '../../config/axios';

const Contact = ({ contact_banner, head_office_address, email, phone_numbers, time }) => {
	const banner = contact_banner?.includes(' ') ? contact_banner.replace(/ /g, '%20') : contact_banner;

	useEffect(() => {
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, []);
	const router = useRouter();
		const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;

	return (
		<>
			<Layout>
				<Head>
				<link rel="canonical" href={canonicalUrl} />
					<title>Contact Kilimanjaro Restaurants | Customer Support </title>
					<meta
						name='description'
						content='Have a question, need help with an order, or want more information? Contact Kilimanjaro Restaurants by phone or email, and our team will be happy to assist you. '
					/>

					<meta name='keyword' content='MEALS FOOD RESTAURANT NIGERIA' />
				</Head>
				<header className='store-header contact-us' style={{ backgroundImage: `url(${banner})` }}>
					<h1 className='visually-hidden'>Contact Us</h1>
				</header>
				<ContactUs
					headOfficeAddress={head_office_address}
					email={email}
					phoneNumbers={phone_numbers}
					time={time}
				/>
			</Layout>
		</>
	);
};

Contact.getInitialProps = async () => {
	try {
		const {
			data: { data: time },
		} = await axiosInstance.get(`settings/get-order-times`);
		const {
			data: {
				data: { contact_banner, head_office_address, email, phone_numbers },
			},
		} = await axiosInstance.get('settings');
		return { contact_banner, head_office_address, email, phone_numbers, time };
	} catch (e) {
		// console.log(e);
		return {};
	}
};

export default Contact;
